<div class="py-4 container-fluid schedule-correction-page">
  <div class="schedule-correction-header">
    <div>
      <h4 class="schedule-correction-title">ตรวจสอบคำขอแก้ไขตารางสอนกรณีพิเศษ</h4>
    </div>
  </div>

  <div class="schedule-correction-card">
    <div class="schedule-correction-card-body">
      <div class="schedule-correction-toolbar" [formGroup]="filterForm">
        <div class="schedule-correction-filter">
          <app-select
            label="เทอมการศึกษา"
            formControlName="academicTerm"
            [options]="academicTermOptions"
            [searchable]="false"
            [clearable]="false"
            inputClass="schedule-correction-select"
            classes="mb-0"
          ></app-select>
        </div>
        <div class="schedule-correction-filter">
          <app-select
            label="ปีการศึกษา"
            formControlName="year"
            [options]="yearOptions"
            [searchable]="false"
            [clearable]="false"
            inputClass="schedule-correction-select"
            classes="mb-0"
          ></app-select>
        </div>
        <div class="schedule-correction-search">
          <app-filter-search-input
            label="ชื่อ - นามสกุล"
            formControlName="keywords"
            inputClass="schedule-correction-search-input"
            ariaLabel="ค้นหาคำขอแก้ไขกรณีพิเศษ"
            classes="mb-0"
            (searchSubmit)="onSearch()"
          ></app-filter-search-input>
        </div>
      </div>

      <div class="schedule-correction-tabs" role="tablist" aria-label="สถานะคำขอแก้ไขกรณีพิเศษ">
        <button
          type="button"
          class="schedule-correction-tab"
          [class.active]="activeTab() === 'all'"
          (click)="onTabChange('all')"
        >
          รายการทั้งหมด
        </button>
        <button
          type="button"
          class="schedule-correction-tab"
          [class.active]="activeTab() === 'pending'"
          (click)="onTabChange('pending')"
        >
          รอดำเนินการ
        </button>
        <button
          type="button"
          class="schedule-correction-tab"
          [class.active]="activeTab() === 'approved'"
          (click)="onTabChange('approved')"
        >
          รับรองแล้ว
        </button>
        <button
          type="button"
          class="schedule-correction-tab"
          [class.active]="activeTab() === 'rejected'"
          (click)="onTabChange('rejected')"
        >
          ปฏิเสธ
        </button>
      </div>

      <ng-template #rowIndexTemplate let-row="row">
        {{ row.sequence ?? '-' }}
      </ng-template>

      <ng-template #statusTemplate let-row="row">
        <span class="schedule-correction-status" [ngClass]="statusBadgeClass(row.status)">
          {{ row.statusLabel }}
        </span>
      </ng-template>

      <ng-template #actionTemplate let-row="row">
        <div class="schedule-correction-actions">
          <button
            type="button"
            class="btn schedule-correction-action-button datatable-view-action-button"
            aria-label="ดูรายละเอียดคำขอแก้ไขกรณีพิเศษ"
            (click)="onView(row)"
          >
            <img
              src="assets/media/icons/svg/eye.svg"
              class="schedule-correction-action-icon datatable-view-action-icon"
              alt=""
              aria-hidden="true"
            />
          </button>
        </div>
      </ng-template>

      <app-datatable
        [datasource]="datasource()"
        [columns]="columns"
        [isLoading]="tableLoading()"
        [limit]="10"
        [showOrder]="false"
        (sortChange)="onSortChange($event)"
      ></app-datatable>

      <app-table-pagination
        [page]="datasource().page"
        [limit]="datasource().limit"
        [total]="datasource().total"
        [totalPage]="datasource().total_page"
        [offset]="datasource().offset"
        [dataLength]="datasource().data.length"
        [isLoading]="tableLoading()"
        [pageSizeOptions]="pageSizeOptions"
        ariaLabel="schedule correction requests pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
    </div>
  </div>
</div>

<div *ngIf="detailOpen()" class="schedule-correction-modal-overlay" role="presentation">
  <section
    class="schedule-correction-modal-panel"
    role="dialog"
    aria-modal="true"
    aria-labelledby="scheduleCorrectionDetailTitle"
  >
    <ng-container *ngIf="selectedRequest() as request">
      <header class="schedule-correction-modal-header">
        <div class="schedule-correction-modal-title-row">
          <h5 id="scheduleCorrectionDetailTitle">รายละเอียดคำขอแก้ไขกรณีพิเศษ</h5>
          <span class="schedule-correction-status" [ngClass]="statusBadgeClass(request.status)">
            {{ statusDisplayLabel(request.status, request.status_label) }}
          </span>
        </div>
        <button type="button" class="btn-close" aria-label="ปิด" (click)="onCloseDetail()"></button>
      </header>

      <div class="schedule-correction-modal-body">
        <div class="schedule-correction-detail-grid">
          <div>
            <span>ชื่อ - นามสกุล</span>
            <strong>{{ teacherDisplayName(request) }}</strong>
          </div>
          <div>
            <span>อีเมล</span>
            <strong>{{ request.schedule_submission?.teacher?.email ?? request.requested_by?.email ?? '-' }}</strong>
          </div>
          <div>
            <span>ภาคการศึกษา</span>
            <strong>{{ academicTermLabel(request) }}</strong>
          </div>
          <div>
            <span>วันที่ส่งคำขอ</span>
            <strong>{{ formatDateTime(request.requested_at) }}</strong>
          </div>
        </div>

        <div class="schedule-correction-section">
          <h6>รายวิชาที่ต้องการแก้ไข</h6>
          <div class="schedule-correction-course-list">
            <div
              *ngFor="let item of request.items ?? []"
              class="schedule-correction-course-item"
            >
              <div class="schedule-correction-course-main">
                <strong>{{ itemSubjectCode(item) }} - {{ itemSubjectName(item) }}</strong>
                <span>Section: {{ item.section ?? item.approvable?.section ?? '-' }}</span>
                <span>ประเภทการสอน: {{ itemTeachingType(item) }}</span>
                <span>รูปแบบภาระงาน: {{ workloadSplitLabel(item) }}</span>
              </div>
              <div class="schedule-correction-course-note">
                <span>หมายเหตุของรายวิชานี้</span>
                <p>{{ item.teacher_note || '-' }}</p>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="request.reviewed_at || request.vice_dean_comment"
          class="schedule-correction-section"
        >
          <h6>ผลการพิจารณา</h6>
          <p><strong>ผู้พิจารณา:</strong> {{ request.reviewed_by?.full_name ?? '-' }}</p>
          <p><strong>วันที่พิจารณา:</strong> {{ formatDateTime(request.reviewed_at) }}</p>
          <p><strong>ความคิดเห็น:</strong> {{ request.vice_dean_comment || '-' }}</p>
        </div>
      </div>

      <footer *ngIf="canReview(request)" class="schedule-correction-modal-footer">
        <button
          type="button"
          class="btn schedule-correction-danger-button"
          [disabled]="actionLoading()"
          (click)="onOpenReject()"
        >
          ปฏิเสธ
        </button>
        <button
          type="button"
          class="btn schedule-correction-primary-button"
          [disabled]="actionLoading()"
          (click)="onOpenApprove()"
        >
          รับรอง
        </button>
      </footer>
    </ng-container>
  </section>
</div>

<div *ngIf="approveOpen()" class="schedule-correction-modal-overlay schedule-correction-modal-overlay-stacked" role="presentation">
  <section
    class="schedule-correction-review-panel"
    role="dialog"
    aria-modal="true"
    aria-labelledby="scheduleCorrectionApproveTitle"
  >
    <header class="schedule-correction-modal-header">
      <h5 id="scheduleCorrectionApproveTitle">ต้องการรับรองคำขอแก้ไขตารางสอนกรณีพิเศษใช่หรือไม่?</h5>
      <button type="button" class="btn-close" aria-label="ปิด" (click)="onCloseApprove()"></button>
    </header>
    <div class="schedule-correction-review-body">
      <p>เมื่อรับรองแล้ว จะถูกส่งกลับไปแก้ไข และเจ้าหน้าที่ที่เกี่ยวข้องจะสามารถดำเนินการแก้ไขได้</p>
      <footer class="schedule-correction-modal-footer">
        <button type="button" class="btn schedule-correction-back-button" [disabled]="actionLoading()" (click)="onCloseApprove()">ยกเลิก</button>
        <button type="button" class="btn schedule-correction-primary-button" [disabled]="actionLoading()" (click)="onConfirmApprove()">
          {{ actionLoading() ? 'กำลังดำเนินการ...' : 'ยืนยันรับรอง' }}
        </button>
      </footer>
    </div>
  </section>
</div>

<div *ngIf="rejectOpen()" class="schedule-correction-modal-overlay schedule-correction-modal-overlay-stacked" role="presentation">
  <section
    class="schedule-correction-review-panel"
    role="dialog"
    aria-modal="true"
    aria-labelledby="scheduleCorrectionRejectTitle"
  >
    <header class="schedule-correction-modal-header">
      <h5 id="scheduleCorrectionRejectTitle">กรุณาระบุเหตุผลที่ปฏิเสธคำขอแก้ไข</h5>
      <button type="button" class="btn-close" aria-label="ปิด" (click)="onCloseReject()"></button>
    </header>
    <form class="schedule-correction-review-body" [formGroup]="rejectForm" (ngSubmit)="onConfirmReject()">
      <app-textarea
        label="เหตุผลที่ปฏิเสธ"
        formControlName="comment"
        [rows]="5"
        [required]="true"
        [error]="rejectForm.controls.comment.invalid && rejectForm.controls.comment.touched ? rejectForm.controls.comment.errors : null"
        classes="mb-0"
      ></app-textarea>
      <footer class="schedule-correction-modal-footer">
        <button type="button" class="btn schedule-correction-back-button" [disabled]="actionLoading()" (click)="onCloseReject()">ยกเลิก</button>
        <button type="submit" class="btn schedule-correction-danger-button" [disabled]="actionLoading()">
          {{ actionLoading() ? 'กำลังดำเนินการ...' : 'ยืนยันปฏิเสธ' }}
        </button>
      </footer>
    </form>
  </section>
</div>
